import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Bu sistem kurum içinde kullanım için uygun mudur?',
  a: 'Sistem, raporlama ve belge düzenleme sürecini desteklemek üzere tasarlanmıştır. Kurumunuzun bilgi güvenliği, gizlilik ve veri işleme kurallarına uymalısınız. Kişisel veya hassas verileri yetkisiz araçlarla paylaşmayın. Kurum içi kullanım uygunluğu, ilgili kurumun kurallarına ve yetkili değerlendirmesine bağlıdır.'
}, {
  q: 'Yapay zekâ konusunda teknik uzman olmam gerekiyor mu?',
  a: 'Hayır. Komutlar, kopyalanıp uyarlanabilecek biçimde yapılandırılmıştır. İlgili alanları mevcut bilgilerinizle doldurabilir ve çıkan metni inceleyebilirsiniz.'
}, {
  q: 'Bu tek seferlik bir ödeme midir?',
  a: 'Ürün, satın alma sırasında gösterilen koşullar çerçevesinde tek seferlik ödeme modeliyle sunulur. Erişim ve güncelleme koşullarını ödeme öncesinde inceleyin.'
}, {
  q: 'Yapay zekâ raporları otomatik olarak doğru hâle getirir mi?',
  a: 'Hayır. Yapay zekâ, verilen bilgilerden yararlanarak bir taslak oluşturabilir; ancak gerçeklerin, kaynakların, tarihlerin ve hukuki referansların doğruluğunu garanti etmez. Nihai inceleme ve onay kullanıcıya aittir.'
}, {
  q: 'Hangi yapay zekâ araçlarıyla kullanılabilir?',
  a: 'Komutlar ChatGPT, Claude, Gemini ve DeepSeek gibi metin tabanlı yapay zekâ araçlarıyla kullanılmak üzere hazırlanmıştır. Özellikler ve kullanım koşulları seçtiğiniz platforma göre değişebilir.'
}, {
  q: 'Kişisel ve hassas bilgiler konusunda nelere dikkat etmeliyim?',
  a: 'Yalnızca kullanmaya yetkili olduğunuz bilgileri paylaşın. Kişisel verileri, gizli kayıtları ve hassas operasyonel bilgileri kurumunuzun izin verdiği güvenli ortamlar dışında kullanmayın. Gerekli olduğunda kimlik belirleyici bilgileri çıkarın veya anonimleştirin.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Sıkça sorulan sorular" className="bg-transparent" data-id="element-41" data-mp="n22j6o97ujmo">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-42" data-mp="2po7w9dblcyts">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-43" data-mp="2kulwumufurfx">
          ❓ Sıkça Sorulan Sorular
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-44" data-mp="2ay0r1zalhcb1">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-45" data-mp="33mep2f1oo8ml" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-46" data-mp="33m4vyilcdlco">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-47" data-mp="1n8o8w9xahtwl">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-48" data-mp="1j61lqmbkcx5q" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-49" data-mp="1j8nsijqmr8mw" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="3urtpb254qxr4">
                  <div className="overflow-hidden" data-id="element-51" data-mp="7o5p1werqs94">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-52" data-mp="cfx7tkrontop">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}